import { render, staticRenderFns } from "./NotFoundForm.vue?vue&type=template&id=1ee0c581&"
import script from "./NotFoundForm.vue?vue&type=script&lang=js&"
export * from "./NotFoundForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports